import { render, staticRenderFns } from "./FaqSearch.vue?vue&type=template&id=561b1e69&"
import script from "./FaqSearch.vue?vue&type=script&lang=js&"
export * from "./FaqSearch.vue?vue&type=script&lang=js&"
import style0 from "./FaqSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports